<div class="card mb-3">
    <div class="card-body">
        <h5 class="mt-0 mb-2 text-primary">
            <i [class]="icon"></i>
            {{title}}
        </h5>

        <div *ngIf="isLoading" class="loading">
            <div class="text-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <div *ngIf="hasError" class="error">
            <div class="alert alert-danger" role="alert">
                Ocurrió un error al cargar los datos.
            </div>
        </div>

        <div *ngIf="isNoData" class="no-data">
            <div class="alert alert-primary" role="alert">
                No hay datos disponibles para mostrar.
            </div>
        </div>

        <div class="chart-container">
            <canvas [id]="chartId"></canvas>
        </div>
    </div>
</div>